var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-h4"},[_vm._v("Are you moving phone numbers from your previous provider?")]),_c('v-radio-group',{attrs:{"value":_vm.getProductInfo().porting},on:{"change":_vm.setPortingAnswer}},[_c('v-radio',{attrs:{"label":"Yes","value":"y"}}),_c('v-radio',{attrs:{"label":"No","value":"n"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }